import * as React from "react";
import Metatags from "@ADC/components/Metatags";
import Layout from "@ADC/components/Layout";
import Loader from "@ADC/components/Views/Loader";
import { Header, Footer } from "@ADC/components/Views";
import Steps from "@ADC/components/Pages/Home/Form-2/Steps";

import "./Blog.css";

const IndividualBlogPage = ({ serverData: { blog, image } }) => {
  const [loading, setLoading] = React.useState(true);
  console.log("Blog Data:", blog);

  const date = new Date(blog?.date);
  const month = date.toLocaleString("default", { month: "long" });

  const decodeHTML = (html) => {
    const txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  };

  React.useEffect(() => {
    setLoading(false);
    // eslint-disable-next-line
  }, []);

  return (
    <Layout className="w-full h-full pt-[85px] lg:pt-32 desktop:pt-[150px] overflow-x-hidden">
      <Header isLight />
      <section className="bg-white pt-16">
        <div className="container">
          {loading ? (
            <Loader />
          ) : blog ? (
            <React.Fragment>
              <div className="mx-auto max-w-[600px]">
                <div className="flex items-center justify-center gap-3">
                  <h5 className="text-sky-700 font-semibold capitalize">
                    {blog?.link?.split("/")[3].replace(/-/g, " ")}
                  </h5>
                  <p className="text-base text-gray-500">
                    {month} {date.getDate()}, {date.getFullYear()}
                  </p>
                </div>
                <h1 className="text-green-700 text-[44px] leading-normal text-center font-semibold my-10">
                  {decodeHTML(blog?.title)}
                </h1>
              </div>
              <div className="max-w-[842px] mx-auto">
                <img
                  src={image?.source_url}
                  className="w-full h-auto mb-6"
                  alt="Blog"
                />
                <div
                  className="text-custom-primary blog-detailed border-b"
                  dangerouslySetInnerHTML={{
                    __html: blog?.content,
                  }}
                />
                <Steps />
              </div>
            </React.Fragment>
          ) : (
            <React.Fragment>
              <h1 className="text-sky-700 text-8xl leading-normal text-center font-bold mb-2">
                404
              </h1>
              <h2 className="text-[44px] leading-normal text-center font-semibold">
                Not found.
              </h2>
            </React.Fragment>
          )}
        </div>
      </section>
      <Footer />
    </Layout>
  );
};

export default IndividualBlogPage;

export const Head = ({ serverData: { blog } }) => (
  <Metatags
    pageTitle={blog.title}
    metaTitle={blog.title}
    description={blog.metaDescription}
    imageUrl={blog.metaImageUrl}
    datePublished={blog.datePublished}
    dateModified={blog.dateModified}
    path={`/blogs/${blog.slug}/`}
    type="article"
  />
);

export async function getServerData({ params: { slug } }) {
  try {
    const res = await fetch(
      `https://blog.affordabledebtconsolidation.com/index.php/wp-json/wp/v2/posts?per_page=100&slug=${slug}`
    );

    if (!res.ok) {
      throw new Error(`Response failed`);
    }
    const blogData = await res.json();
    const imageRes = await fetch(
      `https://blog.affordabledebtconsolidation.com/index.php/wp-json/wp/v2/media/${blogData[0].featured_media}`
    );
    const image = await imageRes.json();

    if (blogData) {
      const blog = blogData[0];

      return {
        props: {
          blog: {
            id: blog?.id,
            date: blog?.date,
            link: blog?.link,
            title: blog?.title.rendered,
            content: blog?.content.rendered,
            metaTitle: blog?.yoast_head_json.title,
            metaDescription: blog?.yoast_head_json.description,
            metaImageUrl: blog?.yoast_head_json.og_image[0].url,
            datePublished: blog?.yoast_head_json.article_published_time,
            dateModified: blog?.yoast_head_json.article_modified_time,
            slug: blog?.slug,
          },
          image,
        },
      };
    } else {
      return {
        props: { blog: null },
      };
    }
  } catch (error) {
    return {
      status: 500,
      headers: {},
      props: {},
    };
  }
}
